import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentRefererGet = {
    path: "/consent/referer",
    method: RouteHttpVerb.GET
};
